// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"382":"30","443":"about"}[chunkId] + "." + {"382":"9ca345a3","443":"f370f9b6"}[chunkId] + ".js";
};